const isLocalhost = window.location.origin.includes("localhost");
const isWebApp = window.location.origin.includes(".web.app");

const redirectUri = isLocalhost
  ? "http://localhost:3000/auth-redirect"
  : isWebApp
  ? "https://cardsdirect-analytics.web.app/auth-redirect"
  : "https://cardsdirect-analytics.web.app/auth-redirect";

export const msalConfig = {
  auth: {
    clientId: "438b6771-aac2-405b-8dc1-55ede9fb07b6",
    authority:
      "https://login.microsoftonline.com/73890052-7df3-4774-bed7-b43d5ebd83db",
    redirectUri: redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage", // Tokens stored here are cleared when the session ends
    storeAuthStateInCookie: true, // Typically not needed unless supporting legacy browsers like IE11
  },
};

// Scopes for accessing Microsoft Graph API
export const graphApiScopes = {
  scopes: ["https://graph.microsoft.com/User.Read.All"],
};

// Scopes for accessing Power BI API
export const powerBiScopes = {
  scopes: ["https://analysis.windows.net/powerbi/api/.default"],
};

// Define loginRequest with Graph API scopes
export const loginRequest = {
  scopes: [...graphApiScopes.scopes],
};
